export default __webpack_public_path__ + "static/media/cp_geo_bb.b0e17174.svg";